




































import { Component, Prop, Vue } from 'vue-property-decorator'

import PersonWidgetWrapper from '@/components/PersonWidgetWrapper.vue'

import CreditNote from '../models/credit-note'

@Component({
  components: {
    PersonWidgetWrapper,
  },
})
export default class CreditNoteWidget extends Vue {
  @Prop() creditNote!: CreditNote
}
